// The language selector itself is a native <select> with an inline
// onchange handler — no JS init needed.
//
// This file only handles the "Save and change language" modal on the
// products.edit page: click a locale tile → write the code into the
// form's hidden input and submit.

export function initLangSelects() {
    // no-op kept for compatibility with callers that still invoke it
}

document.addEventListener('DOMContentLoaded', () => {
    if (document.body.dataset.langTileInit) return;
    document.body.dataset.langTileInit = '1';

    const tiles = document.querySelectorAll('[data-lang-tile]');
    console.log('[lang-tile] found', tiles.length, 'tiles');

    tiles.forEach((tile) => {
        tile.addEventListener('click', () => {
            const code = tile.getAttribute('data-code');
            const form = document.querySelector('form[data-product-edit-form]');
            if (!form) {
                console.warn('[lang-tile] product edit form not found');
                return;
            }

            const upsertHidden = (name, value) => {
                // Remove any existing input with this name (handles the
                // pre-declared <input name="lang_target"> at the bottom of
                // the product edit form as well as previous click cycles).
                form.querySelectorAll('input[type="hidden"][name="' + name + '"]').forEach(n => n.remove());
                const el = document.createElement('input');
                el.type = 'hidden';
                el.name = name;
                el.value = value;
                form.appendChild(el);
                return el;
            };

            upsertHidden('switch_to_locale', code);
            upsertHidden('action', 'change_lang');

            const fd = new FormData(form);
            const allKeys = [];
            const summary = {};
            for (const [k, v] of fd.entries()) {
                allKeys.push(k);
                if (k === 'switch_to_locale' || k === 'lang_target' || k === 'action' || k === '_method' || k === '_token') {
                    summary[k] = v;
                }
            }
            console.log('[lang-tile] submitting', {
                code,
                formAction: form.getAttribute('action'),
                method: form.method,
                relevantFields: summary,
                allFieldNames: allKeys,
            });

            form.submit();
        });
    });
});
